import { useDispatch, useSelector } from 'react-redux';
import RadioButtonsGroup from '../../RadioButtonsGroup';
import GenericBarChart from '../../Charts/GenericBarChart';
import {
  setConcretedOperations,
  setPerformanceModals,
} from '@/store/slices/components/dashboard/DashboardSlice';
import { PROPERTY_OPERATIONS } from '../../constants';
import PerformanceCard from '../PerformanceCard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceConcretedOperationsCard } from '@/store/slices/components/dashboard/service';
import { useTrackPerformanceTabCard } from '../../customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '../../constants/track';

export default function ConcretedOperations() {
  const dispatch = useDispatch();
  const { loading, hasFetched, options, selectedOption } = useSelector(
    (state) => state.DashboardSlice.concretedOperations
  );
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const track = useTrackPerformanceTabCard();

  const { value, variation, percentage_status, icon, labels, datasets } =
    options[selectedOption];

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceConcretedOperationsCard({ query }));
    },
    [],
    { hasFetched }
  );

  const handleClickRadio = (item) => {
    dispatch(setConcretedOperations({ key: 'selectedOption', value: item.id }));
    track.concretedOperations(TRACK_ELEMENT.RADIO_BUTTON_OPTION);
  };

  const allowedOptions = [
    { id: PROPERTY_OPERATIONS.SALE, text: Trans(translations, 'Sale') },
    {
      id: PROPERTY_OPERATIONS.RENT,
      text: Trans(translations, 'Rent'),
    },
    {
      id: PROPERTY_OPERATIONS.COLLEAGUES,
      text: Trans(translations, 'Colleagues'),
    },
  ];

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'concretedOperations',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <PerformanceCard
      ref={ref}
      loading={loading || isStale}
      id="concreted-operations"
    >
      <PerformanceCard.Header handleClickTableIcon={handleOpenTable}>
        {Trans(translations, 'ConcretedOperations')}
      </PerformanceCard.Header>
      <PerformanceCard.Summary
        value={value}
        icon={icon}
        tendency={variation}
        percentageStatus={percentage_status}
      >
        <RadioButtonsGroup
          allowedOptions={allowedOptions}
          selectedOption={selectedOption}
          onClickRadio={handleClickRadio}
        />
      </PerformanceCard.Summary>
      <PerformanceCard.Content>
        <GenericBarChart labels={labels} datasets={datasets} stacked={false} />
      </PerformanceCard.Content>
    </PerformanceCard>
  );
}
